import types from "./types";
import { CALL_API } from "@cdkglobal/react-core-reduxapi";
import config from "../config/app.conf.json";
import axios from "axios";

export const actions = {
    uploadAppApiIntegrationCSV: ({accessToken, formData}) => {
        return dispatch => {
            dispatch({
                type: types.UPLOAD_APP_API_INTEGRATION_CSV_PATCH_REQUEST
            });
            axios.put(`${config.api.api_gateway_url}/v1/admin/fee-waivers`, formData, {
                headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + accessToken
                }
            }).then(res => {
                dispatch(getResult(types.UPLOAD_APP_API_INTEGRATION_CSV_PATCH_RECEIVE, {...res.data}))
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch(getResult(types.UPLOAD_APP_API_INTEGRATION_CSV_PATCH_ERROR, error.response.data));
                } else {
                    dispatch(getResult(types.UPLOAD_APP_API_INTEGRATION_CSV_PATCH_ERROR, {}))
                }
            })
        }
    },
    resetToInitialState: () => ({type: types.RESET_ALL}),
    uploadSubscriptionOrganisationCSV: ({accessToken, formData}) => {
        return dispatch => {
            dispatch({
                type: types.UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_REQUEST
            });
            axios.put(`${config.api.api_gateway_url}/v1/admin/fee-waivers`, formData, {
                headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + accessToken
                }
            }).then(res => {
                dispatch(getResult(types.UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_RECEIVE, {...res.data}))
            }).catch(error => {
                if(error.response && error.response?.data) {
                    dispatch(getResult(types.UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_ERROR, error.response.data));
                } else {
                    dispatch(getResult(types.UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_ERROR, {}))
                }
            })
        }
    },
    downloadIntegrationCSV: ({ accessToken, startDate, endDate }) => {
    return async (dispatch) => {
      dispatch({ type: types.DOWNLOAD_INTEGRATION_REPORT_CSV_GET_REQUEST });

      try {
        const url = `${config.api.api_gateway_url}/v1/admin/all-integrations?type=default&startDate=${startDate}&endDate=${endDate}`;
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
          },
        });

        dispatch({
          type: types.DOWNLOAD_INTEGRATION_REPORT_CSV_GET_RECEIVE,
          response: response.data,
        });
        return response.data;
      } catch (error) {
        dispatch({
          type: types.DOWNLOAD_INTEGRATION_REPORT_CSV_GET_ERROR,
          response: error?.response?.data || {},
        });
        throw error;
      }
    };
  },
}

const getResult = (actionType, res) => {
    return {
      type: actionType,
      response: res
    };
  };